module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAANCAYAAACKCx+LAAAAXElEQVQYlc3NsQ2DQBSD4e9OV7BGQs8iYZ9I2QJmoWQNyrfHdaR5iigYIG4s/ZbtEhFSLxRs0BIOWFCxo9cM3hjxwAdKRDxxZAs6por1An+zDXOCM73Is1v9Z/AFvj8Oc/MVma8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/发布时间1.png
// module id = BuA3
// module chunks = 1